import React from "react";

interface Props {
    colors: { color: string; isSelected: boolean; }[];
    onColorSelect: (index: number) => void;
}

const CircleChart = ({colors, onColorSelect}: Props) => {
    const handleSegmentClick = (index: number) => {
        onColorSelect(index);
    };

    const createArcPath = (startAngle: number, endAngle: number, innerRadius: number, outerRadius: number) => {
        const startInnerX = 100 + innerRadius * Math.cos((Math.PI / 180) * startAngle);
        const startInnerY = 100 + innerRadius * Math.sin((Math.PI / 180) * startAngle);
        const startOuterX = 100 + outerRadius * Math.cos((Math.PI / 180) * startAngle);
        const startOuterY = 100 + outerRadius * Math.sin((Math.PI / 180) * startAngle);

        const endInnerX = 100 + innerRadius * Math.cos((Math.PI / 180) * endAngle);
        const endInnerY = 100 + innerRadius * Math.sin((Math.PI / 180) * endAngle);
        const endOuterX = 100 + outerRadius * Math.cos((Math.PI / 180) * endAngle);
        const endOuterY = 100 + outerRadius * Math.sin((Math.PI / 180) * endAngle);

        return `
      M ${startInnerX},${startInnerY}
      L ${startOuterX},${startOuterY}
      A ${outerRadius},${outerRadius} 0 0,1 ${endOuterX},${endOuterY}
      L ${endInnerX},${endInnerY}
      A ${innerRadius},${innerRadius} 0 0,0 ${startInnerX},${startInnerY}
      Z
    `;
    };


    return (
        <div
            style={{
                position: "relative",
                width: "100%",
                height: "100%",
                maxWidth: "400px",
                maxHeight: "400px",
                borderRadius: "50%",
                overflow: "visible",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <svg width="100%" height="100%" viewBox="-50 -50 300 300">
                {colors.map((color, i) => {
                    const angleStep = 360 / colors.length;
                    const startAngle = i * angleStep;
                    const endAngle = startAngle + angleStep;
                    const isSelected = color.isSelected;

                    const innerRadius = 40; // Making the sections more narrow
                    const outerRadius = isSelected ? 150 : 120; // Adjusted outer radius

                    return (
                        <g key={i} onClick={() => handleSegmentClick(i)}>
                            <path
                                d={createArcPath(startAngle, endAngle, innerRadius, outerRadius)}
                                fill={color.color}
                                stroke="black"
                                strokeWidth="1"
                                style={{
                                    cursor: "pointer",
                                    transition: "d 0.3s ease", // Smooth transition
                                }}
                            />
                        </g>
                    );
                })}
            </svg>
            <div
                style={{
                    position: "absolute",
                    width: "42%",
                    height: "42%",
                    backgroundColor: "white",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    fontSize: "14px",
                    fontWeight: "bold",
                    border: "1px solid black",
                }}
            >
                SELECT YOUR FAVOURITE IN ORDER
            </div>
        </div>
    );
};

export default CircleChart;
